import t from "@ext/localization/locale/translate";
import { GlassToolbar, GlassToolbarButton, GlassToolbarIcon } from "@ui-kit/GlassToolbar";

export type ScrollToBottomButtonProps = {
	onClick: () => void;
};

export const ScrollToBottomButton = ({ onClick }: ScrollToBottomButtonProps) => (
	<div className="pointer-events-none absolute inset-x-0 bottom-3 flex justify-center">
		<GlassToolbar className="pointer-events-auto rounded-full" variant="single">
			<GlassToolbarButton aria-label={t("agent.scroll-to-bottom")} onClick={onClick}>
				<GlassToolbarIcon icon="arrow-down" />
			</GlassToolbarButton>
		</GlassToolbar>
	</div>
);
